export default {
    '&::-webkit-scrollbar': {
        width: '10px',
        height: '10px'
    },
    '&::-webkit-scrollbar-track': {
        background: '#eee',
        borderRadius: '10px',
        border: '1px solid #ddd'
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#999',
        borderRadius: '10px'
    },
    '&::-webkit-scrollbar-thumb:hover': {
        background: '#333'
    }
};
